import { useUpdateVoucher, Voucher } from "@/shared/core-vouchers";
import { VoucherForm } from "./VoucherForm";
import { z } from "zod";
import { voucherSchema } from "../schemas/voucherSchema";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from "@/ui/chakra/dialog";
import { toast } from "@/ui/chakra/toaster";

interface EditModalVoucherProps {
  selectedVoucher: Voucher;
  isOpen: boolean;
  onClose: () => void;
}

const EditModalVoucher: React.FC<EditModalVoucherProps> = ({
  selectedVoucher,
  isOpen,
  onClose,
}) => {
  const { updateVoucher } = useUpdateVoucher();

  const onSubmit = async (data: z.infer<typeof voucherSchema>) => {
    await updateVoucher(
      {
        id: selectedVoucher.id,
        data: {
          activityLabelId: data.activityLabel.value,
          voucherDate: data.voucherDate,
          voucherTypeId: data.voucherType.value,
          storageId: data.storage.value,
          workOrderId: data.workOrder?.value ?? null,
          costCenterId: data.costCenter.value,
          productApplicantId: data.productApplicant.value,
          clientEntityId: data.clientEntity.value,
          equipmentInstanceId: data.equipmentInstance?.value,
          comment: data.comment,
          products: data.products,
        },
      },
      {
        onSuccess: () => {
          toast({
            title: "Vale actualizado",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
          onClose();
        },
        onError: (error) => {
          toast({
            title: "Error al editar vale de productos",
            description:
              error.response?.data?.message || "Ocurrió un error desconocido",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        },
      },
    );
  };

  return (
    <DialogRoot isOpen={isOpen} onClose={onClose} size="xl">
      <DialogContent maxW="6xl">
        <DialogHeader borderBottomWidth="1px" borderColor="border">
          <DialogTitle>Editar vale de productos</DialogTitle>
        </DialogHeader>
        <DialogCloseTrigger />
        <DialogBody pb={0}>
          <VoucherForm
            selectedVoucher={selectedVoucher}
            onSubmit={onSubmit}
            sumbitButtonText="Actualizar vale"
            variant="modal"
            onCancel={onClose}
          />
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  );
};

export default EditModalVoucher;
